
export const $window = window;
export const $location = $window.location;
export const $document = document;
export const $history = history;